// HeatmapChart.jsx
import moment from "moment";
import { useEffect, useRef } from "react";
import ReactApexChart from "react-apexcharts";
import { useTranslation } from "react-i18next";

const HeatmapChart = ({ data, month, year, chartKey }) => {
  const series = data.map((row) => ({
    name: row.leadTimeGroup,
    data: row.values.map((value, i) => ({
      x: ["0-3", "4-7", "7+"][i],
      y: value,
    })),
  }));

  const {t} = useTranslation();


  const chartId = "heatmap_" + chartKey;
  const options = {
    chart: {
      id: chartId,
      type: "heatmap",
      toolbar: { show: false },
    },
    plotOptions: {
      heatmap: {
        shadeIntensity: 0.5,
        radius: 0,
        useFillColorAsStroke: false,
        colorScale: {
          ranges: [
            { from: 0, to: 10, color: "#8f8caf" },
            { from: 11, to: 50, color: "#6f69b2" },
            { from: 51, to: 100, color: "#524aad" },
            { from: 101, to: 300, color: "#382dae" },
          ],
        },
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        colors: ["#000"],
      },
    },
    // title: {
    //   text: `${moment(month, "MM")?.format("MMM")}, ${year}`,
    //   align: "center",
    //   style:
    // },
    xaxis: {
      type: "category",
    },
    yaxis: {
      title: {
        text: t("Lead Time Group"),
        offsetX: 0,
        style: {
          fontSize: "12px",
          fontWeight: "bold",
          color: "#333",
          fontFamily: "Work Sans, sans-serif",
        },
      },
    },
    legend: {
      show: false, // we’ll create our own
    },
  };

    const containerRef = useRef(null);


useEffect(() => {
    const resizeChart = () => {
      ApexCharts.exec(chartId, "updateOptions", options, false, true);
    };

    const observer = new ResizeObserver(resizeChart);
    if (containerRef.current) observer.observe(containerRef.current);

    window.addEventListener("resize", resizeChart);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", resizeChart);
    };
  }, [options, chartId]);


  return (
    <div>
       <div style={{ marginBottom: -20 }}>
        <p id="font-600" style={{ fontSize: "20px", color: "#382dae", textAlign: "center", marginLeft:"24px" }}>
          {`${moment(month, "MM")?.format("MMM")}, ${year}`}
        </p>
      </div>
     <div ref={containerRef}  style={{ width: '100%', position: 'relative' }}>
        <ReactApexChart
          options={options}
          series={series}
          type="heatmap"
          height={300}
          // width={"100%"}
        />
        {/* <div style={{ marginLeft: 10, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <div style={{
          width: '20px',
          height: '160px',
          background: 'linear-gradient(to top, #382dae, #524aad, #6f69b2, #8f8caf, #c7c6d7)',
          border: '1px solid #ccc'
        }} />
        <div style={{ height: '160px', display: 'flex', flexDirection: 'column-reverse', justifyContent: 'space-between', marginTop: 4 }}>
          {[150, 100, 70, 40, 10, 0].map((label, i) => (
            <span key={i} style={{ fontSize: 12 }}>- {label}</span>
          ))}
        </div>
      </div> */}
      </div>
      <div style={{ marginTop: -20 }}>
        <p style={{ fontSize: "12px", color: "#333", textAlign: "center", fontWeight:"bold", marginLeft:"24px" }}>
          {t("Duration Group")}
        </p>
      </div>
    </div>
  );
};

export default HeatmapChart;
